// extracted by mini-css-extract-plugin
module.exports = {"recipientContainer":"ElectronicDelivery_recipientContainer__1aJ0h","alertCol":"ElectronicDelivery_alertCol__3DuJT","docCheckbox":"ElectronicDelivery_docCheckbox__ejfOT"};